import { makeRequest } from '../client'

export const getMerchantProfile = async (restaurantId) =>
  makeRequest('settings', 'getRestaurantProfile', { restaurantId });

export const getMerchantSettings = async (restaurantId) =>
  makeRequest('settings', 'getRestaurantSettings', { restaurantId });
